/** @jsxImportSource @emotion/react */
import { useLocation, useNavigate } from 'react-router-dom';
import { css } from '@emotion/react';
import { useState } from 'react';
import { IconButton } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import CalcSvg from '../../assets/image/common/calculator.svg';
import ModelNumSvg from '../../assets/image/common/clipboard-text-outline.svg';
import CalcListSvg from '../../assets/image/common/clipboard-text-multiple-outline.svg';
import TransferSvg from '../../assets/image/common/swap-horizontal.svg';

interface MenuProps {
  name: string;
  children: {
    name: string;
    path: string;
    state?: { [key: string]: any };
    icon: string;
  }[];
}

const SiderContent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isCollapsed, setIsCollapsed] = useState(true);

  const onNavigate = (path: string, state?: { [key: string]: any }) => {
    navigate(path, state ? { state } : {});
  };

  const menus: MenuProps[] = [
    {
      name: '単価の試算',
      children: [
        {
          name: '試算する',
          path: '/ModelNumberEdit',
          state: {
            referrer: location.pathname,
            modelNumber: '',
            labelName: '',
          },
          icon: CalcSvg,
        },
        {
          name: '結果一覧',
          path: '/ModelNumberList',
          state: {},
          icon: ModelNumSvg,
        },
      ],
    },
    {
      name: '複数個取りの試算',
      children: [
        // {
        //   name: '試算する',
        //   path: '/TrialCalcEdit',
        //   icon: CalcImg,
        // },
        {
          name: '結果一覧',
          path: '/TrialCalcList',
          icon: CalcListSvg,
        },
      ],
    },
    {
      name: 'データを送る',
      children: [
        {
          name: 'データ転送',
          path: '/DataTransfer',
          icon: TransferSvg,
        },
      ],
    },
  ];

  return (
    <div
      css={css`
        position: fixed;
        top: 56px;
        left: 0;
        width: ${isCollapsed ? 250 : 70}px;
        height: calc(100vh - 56px);
        background-color: #f8fbff;
        border-right: #e6eef8 1px solid;
        text-align: center;
        transition: all 0.3s;
        z-index: 100;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      `}
    >
      <div
        css={css`
          width: 100%;
          display: flex;
          justify-content: flex-end;
          margin-bottom: 32px;
        `}
      >
        <IconButton
          onClick={() => setIsCollapsed(!isCollapsed)}
          css={css`
            border-radius: 0;
            padding: 20px;
            color: ${isCollapsed ? '#1c6ecd' : 'unset'};
            font-size: 20px;
            transition: all 0.3s;

            &:hover {
              background-color: #e6eef8;
            }

            ${!isCollapsed &&
            `
              animation-name: arrow-blink;
              animation-timing-function: step-end;
              animation-iteration-count: infinite;
              animation-duration: 2s;
            `}

            @keyframes arrow-blink {
              0% {
                color: unset;
              }
              50% {
                color: #1c6ecd;
              }
              100% {
                color: unset;
              }
            }
          `}
        >
          {isCollapsed ? <ArrowBack /> : <ArrowForward />}
        </IconButton>
      </div>

      {menus.map((menu) => (
        <div
          key={menu.name}
          css={css`
            text-align: left;
          `}
        >
          <div
            css={css`
              font-weight: bold;
              padding: 0 16px 8px 70px;
              font-size: 18px;
              width: 200px;
              cursor: default;
            `}
          >
            {menu.name}
          </div>

          <ul
            css={css`
              list-style: none;
              padding: 0 0 32px;
              margin: 0;
              display: flex;
              flex-direction: column;
              width: 250px;
            `}
          >
            {menu.children.map((submenu) => (
              <li
                key={submenu.name}
                css={css`
                  display: flex;
                  gap: 16px;
                  align-items: center;
                  cursor: pointer;
                  padding: 16px 24px;
                  transition: all 0.3s;

                  &:hover {
                    background-color: #e6eef8;
                  }
                `}
                onClick={() => onNavigate(submenu.path, submenu.state)}
              >
                <img
                  src={submenu.icon}
                  alt={submenu.name}
                  css={css`
                    height: 30px;
                    width: 30px;
                    opacity: 0.6;
                  `}
                />
                <span
                  css={css`
                    color: #000000;
                    text-decoration: none;
                  `}
                >
                  {submenu.name}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default SiderContent;
